var _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 18,
    height: 15,
    rx: 2,
    stroke: "#FC7B52",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.6C3 8.71634 3.71634 8 4.6 8H19.4C20.2837 8 21 8.71634 21 9.6H3Z",
    fill: "#FC7B52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3L7 6",
    stroke: "#FC7B52",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3L17 6",
    stroke: "#FC7B52",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 4,
    height: 1.6,
    rx: 0.5,
    fill: "#FC7B52"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 16,
    width: 4,
    height: 1.6,
    rx: 0.5,
    fill: "#FC7B52"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 4,
    height: 1.6,
    rx: 0.5,
    fill: "#FC7B52"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16,
    width: 4,
    height: 1.6,
    rx: 0.5,
    fill: "#FC7B52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2da197b156e7756e9d93a3ae322b2a61.svg";
export { ForwardRef as ReactComponent };